import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { DialogForm } from '../../components/DialogForm';
import * as _ from 'lodash';
import { Grid, Select, Typography, MenuItem, Box, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  SERVICE_QUERY_AGGREGATOR,
  FETCH_AUTHENTICATION_QUERY,
  USER_DETAILS,
  ALL_PRATICIPANT_AUTHENTICATION_QUERY
} from '../graphQL/queries';

const useStyle = makeStyles(theme => ({
  select: {
    width: '50%'
  },
  content: {
    textAlign: 'center'
  },
  grid: {
    width: '100%',
    borderBottom: '1px solid #EBEBEB'
  },
  textField: {
    width: '90%'
  },
  headers: {
    color: theme.palette.text.secondary
  }
}));

interface AggregatorSettingsProps {
  participant: any;
  dialogOpen: true | false;
  handleDialogClose: any;
  formData: any;
  edit: true | false;
  subscribedParticipantRefresh: any;
  allAuthentications: any;
  supportUser: true | false;
  formInfo: any;
  authContextList: any;
  getLatestValues: (data: any) => void;
  handleOperationDataChange: (e: any, operation: any, field: string, authList?: any) => void;
  handleDialogSubmit: (FormData: any) => void;
  isServiceAuthentication: (value: any) => void;
  setServiceAuthContext: (auth: any) => void;
  serviceAuthContext?: any;
  serviceAuthentication?: any;
  domain?: any;
  setDomain: (domain: any) => void;
  setRequireTransform: (value: any) => void;
  requireTransform: any;
  setProviderCustomerCodePath: (value: any) => void;
  providerCustomerCodePath: any;
  aggregatorCode?: any;
  authContext?: any;
}

const AggregatorSettingsDialog = (props: AggregatorSettingsProps) => {
  const { handleOperationDataChange, formInfo, handleDialogSubmit, handleDialogClose } = props;
  const classes = useStyle();
  let { participantCode, participantType } = props.participant;

  let aggregatorType: any = '';
  if (participantType === 'PROVIDER') {
    aggregatorType = 'AGGREGATOR';
  } else if (participantType === 'CUSTOMER') {
    aggregatorType = 'CUSTOMER_AGGREGATOR';
  }
  const { data: userData } = useQuery(USER_DETAILS, { fetchPolicy: 'cache-first' });
  const { data: aggregatorsListData } = useQuery(SERVICE_QUERY_AGGREGATOR, {
    variables: { workflowCode: props.formData.workflowCode, participantType: aggregatorType },
    fetchPolicy: 'network-only',
    skip:
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
        ? true
        : !props.formData.workflowCode || aggregatorType === ''
  });

  const { data: authenticationParticipantData } = useQuery(ALL_PRATICIPANT_AUTHENTICATION_QUERY, {
    variables: { participantType: aggregatorType || '' },
    skip:
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
        ? true
        : aggregatorType === ''
  });

  const { data: authParticipantData } = useQuery(FETCH_AUTHENTICATION_QUERY, {
    variables: {
      participantCode: userData?.userProfile?.participantRoleInfos?.[0]?.participant?.participantCode || ''
    },
    skip: !(userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
    userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
      ? true
      : false)
  });

  const [aggregatorsList, setAggregatorsList] = React.useState<any>([]);
  const [aggregatorsAuthList, setAggregatorsAuthList] = React.useState<any>([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [defaultAggregator, setDefaultAggregator] = React.useState<any>('');

  const selectAllHandle = () => {
    setSelectAll(!selectAll);
    setDefaultAggregator('');
  };

  const selectAggregatorHandle = (e: any, operation: any, field: string) => {
    setDefaultAggregator(e.target.value);
    handleOperationDataChange(e, operation, field);
  };
  useEffect(() => {
    let aggregators: any = [];
    _.forEach(aggregatorsListData?.aggregatorInfo || [], (element: any) => {
      const obj = {
        label: element.companyName,
        value: element.participantCode
      };
      aggregators.push(obj);
    });
    if (
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
    ) {
      let participantSupport_aggregators: any = [];
      const obj = {
        label: props.aggregatorCode,
        value: props.aggregatorCode
      };
      participantSupport_aggregators.push(obj);
      setAggregatorsList(participantSupport_aggregators);
    } else {
      setAggregatorsList(aggregators);
    }

    let aggregatorAuth: any = [];
    (userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
    userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
      ? authParticipantData?.allParticipantAuthentication?.content
      : authenticationParticipantData?.allParticipantAuthentication?.content
    )?.map((auth: any) => {
      const obj = {
        label: auth.authContext,
        value: auth.authContext,
        aggregatorCode: auth.participantCode
      };
      aggregatorAuth.push(obj);
    });

    if (
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
    ) {
      let participantSupport_aggregators: any = [];
      const obj = {
        label: props.authContext,
        value: props.authContext,
        aggregatorCode: props.authContext
      };
      participantSupport_aggregators.push(obj);
      setAggregatorsAuthList(participantSupport_aggregators);
    } else {
      setAggregatorsAuthList(aggregatorAuth);
    }
  }, [aggregatorsListData, authParticipantData, userData]);

  const handleAggregatorDialogClose = (formData: any) => {
    handleDialogClose(formData);
    setSelectAll(false);
    setDefaultAggregator('');
  };

  const handleAggregatorDialogSubmit = (fromData: any) => {
    handleDialogSubmit(fromData);
    setSelectAll(false);
    setDefaultAggregator('');
  };

  return (
    <DialogForm
      openFn={props.dialogOpen}
      dataConfig={[]}
      handleDialogClose={() => handleAggregatorDialogClose(props.formData)}
      handleDialogSubmit={() => handleAggregatorDialogSubmit(props.formData)}
      submitlabel={'Save'}
      title={`Aggregator Settings - ${participantCode}`}
      dialogId="aggregator-settings-id"
      closeFn={() => handleAggregatorDialogClose(props.formData)}
      supportUser={props.supportUser}
    >
      <>
        <Box m={1}>
          <Box className={classes.grid} style={{ padding: '8px' }}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <Typography className={classes.headers}>Select All</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography className={classes.headers}>Aggregator</Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={3} alignItems="flex-end">
            <Grid item xs={3}>
              <Checkbox
                data-id={'select-all'}
                checked={selectAll}
                onChange={selectAllHandle}
                name="SelectAll"
                color="primary"
              />
            </Grid>
            <Grid item xs={3}>
              <Select
                id="Aggregator-Service-Select-ALL"
                className={classes.textField}
                label={'Aggregator-All'}
                disabled={!selectAll}
                value={defaultAggregator}
                onClick={e => selectAggregatorHandle(e, 'selectAll', 'selectAll')}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {aggregatorsList?.map((item: any) => [<MenuItem value={item.value}>{item.label}</MenuItem>])}
              </Select>
            </Grid>
          </Grid>
        </Box>
        <Box className={classes.grid}>
          <Grid container spacing={3} alignItems="flex-end">
            <Grid item xs={4} justify="center" alignItems="flex-end">
              <Typography noWrap>Name</Typography>
            </Grid>
            <Grid item xs={2} justify="center" alignItems="flex-end">
              <Typography noWrap>Aggregator</Typography>
            </Grid>
            <Grid item xs={3} justify="center" alignItems="flex-end">
              <Typography>Auth Context</Typography>
            </Grid>
          </Grid>
        </Box>
        {Object.keys(formInfo?.operations || {}).map((operationCode: any) => (
          <Grid container spacing={3} alignItems="flex-end">
            <Grid item xs={4} justify="center" alignItems="flex-end">
              <Typography noWrap>{formInfo.operations[operationCode].operationName}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Select
                id="Aggregator-Service-Select"
                className={classes.textField}
                label={'Aggregator'}
                disabled={props.supportUser || selectAll}
                value={selectAll ? defaultAggregator : formInfo.operations[operationCode].aggregatorCode || ''}
                onClick={e => handleOperationDataChange(e, operationCode, 'aggregatorCode')}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {aggregatorsList.length > 0 &&
                  aggregatorsList?.map((item: any) => [<MenuItem value={item.value}>{item.label}</MenuItem>])}
              </Select>
            </Grid>
            <Grid item xs={2}>
              {/* <Typography noWrap>Aggregator Authentication To use</Typography> */}
              <Select
                id="Operation-AuthContext-Select"
                className={classes.textField}
                label={'Auth Context'}
                disabled={props?.supportUser}
                value={formInfo?.operations?.[operationCode] ? formInfo.operations[operationCode].authContext : ''}
                onChange={e => handleOperationDataChange(e, operationCode, 'authContext')}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {aggregatorsAuthList.length > 0 &&
                  aggregatorsAuthList
                    .filter((auth: any) => auth.aggregatorCode === formInfo.operations[operationCode].aggregatorCode)
                    ?.map((item: any) => [<MenuItem value={item.value}>{item.label}</MenuItem>])}
              </Select>
            </Grid>
          </Grid>
        ))}
      </>
    </DialogForm>
  );
};

export default AggregatorSettingsDialog;
